<template>
    <div
        class="h-screen absolute top-0 right-0 flex items-center justify-center"
        style="background: rgba(0, 0, 0, .5); width: 100%; top: 0; z-index: 9999;"
    >
        <Card class="flex p-4 flex-col max-w-md"
            style="min-width: 348px; max-height: 348px; overflow-y: auto"
        >
            <p class="text-darkPurple font-bold text-lg pb-3 flex gap-3 items-center border-b border-solid border-romanSilver">
                Setting Allocation
            </p>
            <div class="w-full flex flex-col justify-center items-center gap-2 my-4">
                <img :src="require('@/assets/images/download-box.png')" alt="not_found">
                <p class="flex justify-center items-center text-center text-jet font-semibold">
                    To start using documents, please set up your allocated storage in Document Settings.
                </p>                         
            </div>
            <div class="w-full flex justify-center">
                <button
                    class="text-white rounded-lg bg-dynamicBackBtn w-1/2 h-11 flex justify-center items-center outline-none border-none"
                    @click="$router.push({ name: 'Documents' })"
                >
                    Go to Document Settings
                </button>
            </div>
        </Card>
    </div>
</template>
<script>
export default {
    name: "SettingAllocation",
    components: {
        Card: () => import("@/components/Card"),
    },
    data() {
        return {}
    },
};
</script>
<style scoped>
</style>
